export default __webpack_public_path__ + "static/media/roxborough.fbd90b1d.JPG";